<template>
  <div class="file-upload">
    <!--
      This slot is made available for an additional label for this file upload.
    -->
    <slot></slot>

    <div class="file-upload__wrapper">
      <label
        :for="id"
        class="file-upload__upload-button"
        :class="buttonClass"
        v-html="buttonText"
      >
      </label>

      <p class="file-upload__info" v-html="infoMessage"></p>

      <input
        ref="fileInput"
        type="file"
        :id="id"
        :name="controlName"
        :multiple="multiple"
        :accept="fileTypes"
        :required="required"
        v-on:change="handleFileChange($event)"
      />
    </div>
  </div>
</template>

<script lang="js">
export default  {
  name: 'lms-file-upload',
  props: {
    id: {
      type: String,
      default: "file-upload",
    },
    name: {
      type: String,
      default: "file-upload",
    },
    required: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    fileTypes: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "Upload",
    },
    buttonStyle: {
      type: String,
      default: 'primary',
    }
  },
  data() {
    return {
      controlName: (this.multiple) ? `${this.name}[]` : this.name,
      infoMessage: '',
    }
  },
  computed: {
    buttonClass() {
      let cssClasses = 'button';

      if (this.buttonStyle === 'secondary') {
        cssClasses = 'button button--transparent';
      }

      return cssClasses;
    },
  },
  mounted () {
    this.setInformationMessage()
  },
  methods: {
    handleFileChange(event) {
      const fileInput = event.target;

      let fileList = [];
      if (fileInput.files) {
        fileInput.files.forEach((file) => {
          fileList.push(file.name);
        });
      }

      this.setInformationMessage(fileList);
    },
    setInformationMessage(fileList = []) {
      if (Array.isArray(fileList) && fileList.length > 0) {
        this.infoMessage = `${fileList.length} files selected.`;
      }
      else {
        this.infoMessage = 'No files selected.';
      }
    }
  },
}
</script>
